var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/interface/canvas.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"tabs ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "kiosk")?"hide":""), env.opts.autoescape);
output += "\">\r\n\t";
if(runtime.contextOrFrameLookup(context, frame, "activeWindow") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tabs")),"length")) {
output += "\r\n\t\t<div class=\"window-action-bar\">\r\n\t\t\t<!-- <button class=\"button action material-icons\">&#xe5d2;</button> -->\r\n\t\t\t<div class=\"dropdown\">\r\n\t\t\t\t<button class=\"button toggle-menu action material-icons\">&#xe5cf;</button>\r\n\r\n\t\t\t\t<div class=\"menu hide\">\r\n\t\t\t\t\t<a class=\"option\" data-window-event=\"dispose\" data-window-target=\"*\" style=\"font-weight: bold\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"CloseAll"), env.opts.autoescape);
output += "</a>\r\n\t\t\t\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "tabs");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("window", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n\t\t\t\t\t\t<a class=\"option ";
output += runtime.suppressValue((t_4 == runtime.contextOrFrameLookup(context, frame, "activeWindow")?"selected":""), env.opts.autoescape);
output += "\" href=\"#";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue((lineno = 10, colno = 104, runtime.callWrap(runtime.memberLookup((t_4),"title"), "window[\"title\"]", context, [])), env.opts.autoescape);
output += "</a>\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "activeWindow")),"options")),"noReset") == false) {
output += "<button data-window-event=\"reset\" data-window-target=\"active\" class=\"button action action-reload material-icons\">&#xe5d5;</button>";
;
}
output += "\r\n\t\t\t<button data-window-event=\"dispose\" data-window-target=\"active\" class=\"button action action-close material-icons\">&#xe5cd;</button>\r\n\t\t</div>\r\n\t";
;
}
output += "\r\n\t<div class=\"tab-overflow\">\r\n\t\t";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "tabs");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("window", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\r\n\t\t<div class=\"tab ";
output += runtime.suppressValue((t_8 == runtime.contextOrFrameLookup(context, frame, "activeWindow") || (runtime.memberLookup((t_8),"sub") && runtime.memberLookup((runtime.memberLookup((t_8),"sub")),"window") == runtime.contextOrFrameLookup(context, frame, "activeWindow"))?"selected":""), env.opts.autoescape);
output += "\" data-window-event=\"focus\" data-window-event-preventdefault=\"false\" data-window-target=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue((lineno = 21, colno = 225, runtime.callWrap(runtime.memberLookup((t_8),"title"), "window[\"title\"]", context, [])), env.opts.autoescape);
output += "</div>\r\n\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t</div>\r\n</div>\r\n\r\n<div class=\"jumpstart v-center\">\r\n\t<div>\r\n\t\t";
frame = frame.push();
var t_11 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "shortcuts")),"Start");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("shortcut", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\r\n\t\t<button class=\"button button-default shortcut\" data-menu-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"MenuID"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Text"), env.opts.autoescape);
output += "</button>\r\n\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t</div>\r\n</div>\r\n\r\n<div class=\"";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "kiosk")?"kiosk":""), env.opts.autoescape);
output += "\" data-window-anchor></div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/interface/canvas.html"] , dependencies)